import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/base.scss';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js